import L from "leaflet";

const LeafletMouseControl = L.Control.extend({
    options: {
        position: "bottomleft",
        separator: " , ",
        emptyString: " ",
        lngFirst: false,
        numDigits: 4,
        lngFormatter: undefined,
        latFormatter: undefined,
        prefix: "",
    },

    reverseGeocode: function (lat, lon) {
        var url = `https://nominatim.openstreetmap.org/reverse?lat=${lat}&lon=${lon}&format=json`;
        return fetch(url)
            .then(response => response.json())
            .then(data => {
                if (data && data.display_name) {
                    return data.display_name;
                } else {
                    return "Unknown location";
                }
            })
            .catch(error => {
                console.error("Error fetching reverse geocoding data:", error);
                return "Unknown location";
            });
    },

    isWithinIndia: function (lat, lon) {
        const indiaCoordinates = {
            north: 37.6,
            south: 8.4,
            east: 97.4,
            west: 68.7
        };
        return lat <= indiaCoordinates.north && lat >= indiaCoordinates.south &&
            lon >= indiaCoordinates.west && lon <= indiaCoordinates.east;
    },

    onAdd: function (map) {
        this._map = map;
        this._container = L.DomUtil.create("div");
        L.DomEvent.disableClickPropagation(this._container);
        map.on("mousemove", this._onMouseMove, this);
        map.on("click", this._onMapClick, this); // Listen for map click events

        this._container.innerHTML = this.options.emptyString;
        this._container.style.backgroundColor = "#FFFFFF";
        this._container.style.maxWidth = "330px";

        this._container.style.width = "80%";
        this._container.style.border = "5px solid #BBC2CC";
        this._container.style.borderRadius = "3px";
        this._container.style.marginLeft = "auto";
        this._container.style.marginRight = "auto";

        this._container.style.marginBottom = "15px";
        this._container.style.textAlign = "center";
        this._container.style.zIndex = 1;
        this._container.style.display = "block";
        




       

        this.editableContainer = null;
        this.currentMarker = null;

        this._container.addEventListener("click", (event) => {
            if (!this.editableContainer) {
                this.createEditableContainer();
            }
        });

        return this._container;
    },

    onRemove: function (map) {
        map.off("mousemove", this._onMouseMove);
        map.off("click", this._onMapClick); // Remove map click listener
    },

    _onMouseMove: function (e) {
        if (e.latlng) {
            var latLng = {
                lat: L.Projection.LonLat.project(e.latlng).y,
                lng: L.Projection.LonLat.project(e.latlng).x,
            };
            var lng = this.options.lngFormatter
                ? this.options.lngFormatter(latLng.lng)
                : L.Util.formatNum(latLng.lng, this.options.numDigits);
            var lat = this.options.latFormatter
                ? this.options.latFormatter(latLng.lat)
                : L.Util.formatNum(latLng.lat, this.options.numDigits);

            var content = `
            <div class="latlontooltip">
                <div style="display: inline-block; margin-right: 10px; font-weight: bold; font-size: 13px;">Latitude: ${lat} </div>
                <div style="display: inline-block; font-weight: bold; font-size: 13px;" >Longitude: ${lng}</div>
                <span class="latlontooltiptext">Click to Edit Latitude and Longitude</span>
            </div>
            `;

            if (!this.editableContainer) {
                this._container.innerHTML = content;
            } else {
                this._container.appendChild(this.editableContainer);
            }
        }
    },

    _onMapClick: function (e) {
        if (this.editableContainer) {
            this._container.removeChild(this.editableContainer);
            this.editableContainer = null;
        }
    },

    createEditableContainer: function () {
        this.editableContainer = L.DomUtil.create("div", "editable-container");
        this.editableContainer.id = "editableContainer";
        var editableInput = L.DomUtil.create("input", "editable-input", this.editableContainer);
        editableInput.placeholder = "Enter Latitude, Longitude";
        editableInput.style.textAlign = "center";
        editableInput.style.width = "12rem";
        editableInput.style.position = "sticky";

        var closeButton = L.DomUtil.create("button", "close-button", this.editableContainer);
    //     closeButton.innerHTML = `
    //     <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24">
    //         <path fill="currentColor" d="M18.3 5.71a1 1 0 00-1.42 0L12 10.59 7.12 5.7A1 1 0 105.7 7.12L10.59 12l-4.9 4.88a1 1 0 101.41 1.42l4.88-4.9 4.88 4.9a1 1 0 101.42-1.42L13.41 12l4.88-4.88a1 1 0 000-1.42z"/>
    //     </svg>
    // `;
//     closeButton.innerHTML = `
//     <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24">
//         <path fill="currentColor" d="M12 2a10 10 0 100 20 10 10 0 000-20zm5 13.59L13.59 12 17 8.59 15.59 7 12 10.41 8.41 7 7 8.41 10.41 12 7 15.59 8.41 17 12 13.59 15.59 17 17 15.59z"/>
//     </svg>
// `;
closeButton.innerHTML = `
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24">
        <path fill="currentColor" d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/>
    </svg>
`;

      //  closeButton.innerHTML = "&times;";
        closeButton.style.position = "inherit";
        closeButton.style.top = "0";
        closeButton.style.right = "10";
        closeButton.style.border = "none";
        closeButton.style.background = "none";
        closeButton.style.fontSize = "20px";
        closeButton.style.cursor = "pointer";

        closeButton.addEventListener("click", () => {
            this._container.removeChild(this.editableContainer);
            this.editableContainer = null;
        });

        editableInput.addEventListener("keypress", (event) => {
            if (event.key === "Enter") {
                var input = editableInput.value;
                var coords = input.split(",").map(coord => parseFloat(coord.trim()));
                if (coords.length === 2 && !isNaN(coords[0]) && !isNaN(coords[1])) {
                    if (this.isWithinIndia(coords[0], coords[1])) {
                        this.reverseGeocode(coords[0], coords[1]).then(locationName => {
                            if (this.currentMarker) {
                                this._map.removeLayer(this.currentMarker);
                            }
                            var popupContent = document.createElement('div');
                            popupContent.textContent = `Zoomed to: ${locationName}`;

                            var popup = L.popup({
                                closeButton: true,
                                autoClose: true,
                                closeOnClick: true,
                                className: 'draggable-popup'
                            }).setContent(popupContent);

                            this.currentMarker = L.marker(coords).addTo(this._map);
                            this.currentMarker.bindPopup(popup).openPopup();

                            this._map.setView(coords, 9);

                            // Remove the marker after 5 seconds
                            setTimeout(() => {
                                if (this.currentMarker) {
                                    this._map.removeLayer(this.currentMarker);
                                    this.currentMarker = null;
                                }
                            }, 5000);

                            var draggablePopup = document.querySelector('.draggable-popup');
                            draggablePopup.style.cursor = 'move';
                            var dragStartX, dragStartY;
                            draggablePopup.addEventListener('mousedown', startDrag);

                            function startDrag(event) {
                                dragStartX = event.clientX - draggablePopup.offsetLeft;
                                dragStartY = event.clientY - draggablePopup.offsetTop;
                                document.addEventListener('mousemove', doDrag);
                                document.addEventListener('mouseup', stopDrag);
                            }
                            function doDrag(event) {
                                draggablePopup.style.left = event.clientX - dragStartX + 'px';
                                draggablePopup.style.top = event.clientY - dragStartY + 'px';
                            }
                            function stopDrag() {
                                document.removeEventListener('mousemove', doDrag);
                                document.removeEventListener('mouseup', stopDrag);
                            }
                        });
                    } else {
                        alert("Coordinates are outside India. Zooming to this location is not allowed.");
                    }
                } else {
                    alert("Invalid input. Please enter latitude and longitude in decimal format.");
                }
            }
        });

        this._container.appendChild(this.editableContainer);
        editableInput.focus();
    }
});

export default LeafletMouseControl;
